import React, { useEffect } from 'react';

const Toast = ({ message, type, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(onClose, 4000);
    return () => clearTimeout(timer);
  }, [onClose]);

  const icons = { success: '✓', error: '✕', info: 'ℹ' };
  const colors = { success: 'var(--success)', error: 'var(--error)', info: 'var(--accent-primary)' };

  return (
    <div style={{
      position: 'fixed', bottom: '24px', right: '24px', padding: '14px 20px',
      background: 'var(--bg-card)', border: `1px solid ${colors[type]}`,
      borderRadius: '14px', boxShadow: 'var(--shadow-lg)', zIndex: 2000,
      display: 'flex', alignItems: 'center', gap: '12px', maxWidth: '360px',
      animation: 'slideIn 0.35s cubic-bezier(0.16, 1, 0.3, 1)',
      backdropFilter: 'blur(12px)'
    }}>
      <span style={{ color: colors[type], fontSize: '16px', fontWeight: '600' }}>{icons[type]}</span>
      <span style={{ color: 'var(--text-primary)', fontSize: '14px', flex: 1, lineHeight: '1.4' }}>{message}</span>
      <button onClick={onClose} style={{ background: 'none', border: 'none', color: 'var(--text-muted)', cursor: 'pointer', fontSize: '16px', padding: '2px' }}>×</button>
    </div>
  );
};

export default Toast;
